export enum RequestStatus {
  IDLE,
  LOADING,
  READY,
  FAILED,
}
